import i18next from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

// Get the saved language from localStorage or use 'pt' as the default
const savedLanguage = localStorage.getItem('selectedLanguage') || 'pt';

const localeLoaders = import.meta.glob('./locales/*/*.json', { query: 'json' });

i18next
  .use(
    resourcesToBackend((language, namespace, callback) => {
      const key = `./locales/${language}/${namespace}.json`;
      const loader = localeLoaders[key];
      if (!loader) {
        return callback(new Error(`Missing locale file: ${key}`), null);
      }
      loader()
        .then((module) =>
          callback(
            null,
            (module as { default: { [key: string]: string } }).default
          )
        )
        .catch((err) => callback(err, null));
    })
  )
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    debug: false,
    fallbackLng: 'pt',
    saveMissing: true,
    react: { useSuspense: true },
  });

// persist future language changes
i18next.on('languageChanged', (lng) => {
  localStorage.setItem('selectedLanguage', lng);
});

export default i18next;
